export function formatePhoneNumber(str: string): string {
  return str.replace(/(\s+|_|\D|-|\(|\))/g, '').trim();
}
